import { BsGearFill } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';

const PostMailingAdvancedTab = () => (
	<Card>
		<div className="text-center py-12">
			<div className="w-14 h-14 bg-bgBase-400 rounded-full flex items-center justify-center mx-auto mb-4">
				<BsGearFill className="w-7 h-7 text-bgBase-800" />
			</div>
			<h3 className="text-md font-semibold mb-1">Keine erweiterten Einstellungen</h3>
			<p className="text-sm text-bgBase-800">
				Für diese Kampagne sind derzeit keine erweiterten Optionen verfügbar.
			</p>
		</div>
	</Card>
);

export default PostMailingAdvancedTab;
